import { lookupTicketCode } from "@/js/ticketCodeLookup.js";

export default {
  data() {
    return {
      ticketSearchCode: "",
      ticketResult: null,
      ticketModalOpen: false,
      ticketLookupLoading: false,
      ticketLookupError: null,
    };
  },
  methods: {
    async executeTicketLookup(code = this.ticketSearchCode) {
      if (!code) {
        return;
      }

      this.ticketLookupLoading = true;
      this.ticketLookupError = null;
      this.$store.commit("showLoading");
      try {
        const result = await lookupTicketCode({ code, store: this.$store });
        if (!result) {
          this.ticketLookupError = "not-found";
          this.$store.commit("showMessage", "存在しないコードです");
          return;
        }
        this.ticketResult = result;
        this.ticketModalOpen = true;
      } catch (error) {
        this.$handleError("043", error);
        this.ticketLookupError = "unexpected";
      } finally {
        this.ticketLookupLoading = false;
        this.$store.commit("hideLoading");
      }
    },
  },
};
